export default __webpack_public_path__ + "static/media/4.d293f8e2.jpg";